import { gentminvparams } from "../services/tminvparams";
export const datapop = (data, type) => {
  if (data) {
    if (type === "customers - custreducer") {
      return dispatch => {
        return gentminvparams(data).then(customers => {
          dispatch({ type: type, payload: customers });
        });
      };
    } else {
      return {
        type: type,
        payload: data
      };
    }
  } else {
    return {
      type: type
    };
  }
};



// WEBPACK FOOTER //
// ./src/actions/data-populate.js